import Tab from './tab';
import TabItem from './item';
import './styles/index.scss';
const ExpandedTab = Tab;
ExpandedTab.Item = TabItem;
export default ExpandedTab;
